import { gql } from '@apollo/client'

export const PAUSE_AUTOMATION = gql`
  mutation pauseAutomation($automationId: String!) {
    pauseAutomation(automationId: $automationId)
  }
`

export const RESUME_AUTOMATION = gql`
  mutation resumeAutomation($automationId: String!) {
    resumeAutomation(automationId: $automationId)
  }
`

export const CANCEL_AUTOMATION = gql`
  mutation cancelAutomation($automationId: String!) {
    cancelAutomation(automationId: $automationId)
  }
`

export const RESTART_AUTOMATION = gql`
  mutation restartAutomation(
    $groupId: String!
    $projectId: String!
    $coverType: String!
    $entities: [String!]!
    $removeExistingPages: Boolean!
  ) {
    restartAutomation(
      groupId: $groupId
      projectId: $projectId
      coverType: $coverType
      entities: $entities
      removeExistingPages: $removeExistingPages
    ) {
      automationId
      projectId
    }
  }
`
